import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,           // { id, name, phone, email, role }
    companyId: null,
    accessToken: null,    // kept in memory (NOT localStorage — XSS safe)
    permissions: [],      // ['attendance:view_all', 'payroll:run_payroll', ...]
    isAuthenticated: false,
    isLoading: false,
  },
  reducers: {
    setAuth: (state, action) => {
      const { user, companyId, accessToken, permissions } = action.payload;
      state.user = user;
      state.companyId = companyId;
      state.accessToken = accessToken;
      state.permissions = permissions;
      state.isAuthenticated = true;
    },
    clearAuth: (state) => {
      state.user = null;
      state.companyId = null;
      state.accessToken = null;
      state.permissions = [];
      state.isAuthenticated = false;
    },
    updateToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    updateUser: (state, action) => {
      if (state.user) state.user = { ...state.user, ...action.payload };
    },
  },
});

export const { setAuth, clearAuth, updateToken, setLoading, updateUser } = authSlice.actions;
export default authSlice.reducer;

export const selectUser = (state) => state.auth.user;
export const selectCompanyId = (state) => state.auth.companyId;
export const selectPermissions = (state) => state.auth.permissions;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAccessToken = (state) => state.auth.accessToken;
